import { firebase } from 'src/db/db';
const storageRef = firebase.storage().ref();

/**
 * getVoiceover - Return array of all voiceover files for given musician.
 * 
 * @param {*} musician - musician to get music for.
 */
const getVoiceover = async (musician) => {
    const audioArray = [];
    const res = await storageRef.child("musicians/" + musician + "/alexa").listAll()
    for (let i = 0; i < res.items.length; i++) {
        const url = await res.items[i].getDownloadURL()
        audioArray.push({
            url: url,
            name: res.items[i].name
        });
    }
    return audioArray;
}

export {
    getVoiceover
}